import { Injectable } from '@angular/core';
import { ParametersService } from './service/parameters.service';
import { Damage, DamageAnalysis } from './model/damage.model';
import { SearchTagCheckbox } from './model/search';
import { VehicleDamagePipe } from './pipes/vehicle-damage.pipe';
import { ClassificationService } from './service/classification.service';
import { ThumbnailService } from './service/thumbnail.service';
import { SearchService } from './service/search.service';

@Injectable()
export class DamageFilterService {

  constructor(private readonly _parametersService: ParametersService,
    private readonly _vehicledamage: VehicleDamagePipe,
    private readonly _classificationService: ClassificationService) { }

  damageFilterParent = true
  damageFilterValue = false

  //// Filter For Damage Analysis : 
  tchekId: string
  filterDamageByType: SearchTagCheckbox[] = [];
  async setHideDamageList(damages: DamageAnalysis[], tchekId: string, finderDataTag?): Promise<SearchTagCheckbox[]> {
    console.log('classification test 1', this._classificationService.active, finderDataTag);

    if (this._classificationService.active) {
      this.damageFilterParent = false
      this.damageFilterValue = false
    }

    if (this._classificationService.active === false && tchekId !== this.tchekId)
      this.filterDamageByType = []
    this.tchekId = tchekId

    damages.forEach(dam => {
      let index = this.filterDamageByType.findIndex(d => { return d.value === `${dam.type} ${dam.sev}` });
      if (index === -1) {
        if (dam.sev !== undefined && dam.sev !== null)
          this.filterDamageByType.push({ display: `${this._vehicledamage.transform(dam.type)} ${dam.sev}`, value: `${dam.type} ${dam.sev}`, checked: false })
        else
          this.filterDamageByType.push({ display: this._vehicledamage.transform(dam.type), value: `${dam.type} ${dam.sev}`, checked: false })
      }
      index = this.filterDamageByType.findIndex(d => { return d.value === 'added' });
      if (index === -1 && dam.isAuto !== true)
        this.filterDamageByType.push({ display: this._vehicledamage.transform('added'), value: 'added', checked: false })
    })

    if (this._classificationService.active && finderDataTag) {
      console.log('classification test 2 ', this._classificationService.active);
      let goodType = [];
      finderDataTag.forEach(element => {
        if (element.checked === true)
          goodType.push(element.value.toString().substr(1))
      });
      this.filterDamageByType.forEach(t => {
        t.checked = true;
        goodType.forEach(goodT => {
          if (t.checked === true && t.value.toString().startsWith(goodT))
            t.checked = false
        })
      })
    }

    return this.filterDamageByType
  }


  //// Filters For IA Result : 

  public async applyFiltersIA(damagesFound: Damage[], filter: boolean): Promise<Damage[]> {
    if (damagesFound[0] && filter) {
      damagesFound = await this.settingsFilterDamage(damagesFound)
    }
    return damagesFound
  }

  public settingsFilterDamage(damages): Promise<any> {
    console.log('classification test 3', this._classificationService.active);

    return new Promise((resolve, reject) => {
      let filter = this._parametersService.getAll().filterDamage;
      if (this._classificationService.active) {
        this.damageFilterParent = false
        this.damageFilterValue = false
      }
      let damageTmp = damages
      if (filter && damages && this.damageFilterValue) {
        damageTmp = []
        damages.forEach((dam: Damage) => {
          let index = filter.findIndex(filter => { return dam.type === filter.type });
          filter.forEach(filter => {
            let index2 = damageTmp.findIndex(d => { return dam === d });
            if (index2 === -1) {
              if (dam.isAuto && index !== -1
                && (dam.detectionCount || dam.percentBestRoi)) {
                if (dam.type === filter.type) {
                  if ((dam.detectionCount
                    && dam.percentBestRoi !== null
                    && dam.detectionCount >= filter.number
                    && parseInt(dam.percentBestRoi, 10) >= filter.proba)
                    || (dam.detectionCount
                      && dam.percentBestRoi === null
                      && dam.detectionCount >= filter.number)) {
                    damageTmp.push(dam)
                  }
                }
              } else {
                damageTmp.push(dam)
              }
            }
          })
        })
      }

console.log("filter parent " , !(this.damageFilterParent && damages && damages[0] && [4,5].includes(damages[0].tchekPtr.type)));
  	if (this.damageFilterParent && damages && damages[0] && [4,5,2].includes(damages[0].tchekPtr.type))
	    this.damageFilterParent = false

      if (this.damageFilterParent && [4,5,2].includes(damages[0].tchekPtr.type)) {
        damageTmp = damageTmp.filter(dam => { return ((dam.parentPtr && dam.parentPtr.id !== dam.id) || dam.isAuto !== true) })
      }
      damages = damageTmp;
      resolve(damages);
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/damage-filter.service.ts